exports.components = {
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-musclequest-tsx": () => import("./../../../src/pages/musclequest.tsx" /* webpackChunkName: "component---src-pages-musclequest-tsx" */)
}

